import DataStoreRecordBehaviors, {
  type IDataStoreRecordBehaviors,
} from '../collaboration/DataStoreRecordBehaviors';
import { type Constructor } from '../types';
import { type fabric } from 'fabric';
import Client from '../collaboration/Client';
import type WhiteboardController from '../controllers/WhiteboardController';

// Behaviours added onto objects that support saving the object and its
// properties to the server.
interface LocalCollaborationBehaviors {
  created(controller: WhiteboardController): void;
  deleted(controller: WhiteboardController): void;
}

interface CollaborationBehaviors
  extends LocalCollaborationBehaviors,
    DataStoreRecordBehaviors {}

// eslint-disable-next-line @typescript-eslint/no-redeclare
function CollaborationBehaviors(
  Base: Constructor<fabric.Object & IDataStoreRecordBehaviors>
): any {
  return DataStoreRecordBehaviors(
    class extends Base implements LocalCollaborationBehaviors {
      created(controller: WhiteboardController) {
        if (Client.ignoredObjectTypes.includes(this.type)) return;

        // Adds controller to objects created entirely in fabric (e.g., Path)
        if (!this.controller) this.controller = controller;

        controller.dataStoreObjects.addRecord(this);
      }

      deleted(controller: WhiteboardController) {
        if (Client.ignoredObjectTypes.includes(this.type)) return;

        if (this.locked) return;

        // Ensure objects can only be deleted once. This fixes a problem where
        // objects that contain other objects can cause a double-delete if the
        // parent and child are both selected and deleted
        if (this.markedDeleted) {
          return;
        }

        this.markedDeleted = true;

        super.deleted(controller);

        controller.dataStoreObjects.removeRecord(this);
        controller.canvas.remove(this);
      }
    }
  );
}

export default CollaborationBehaviors;
